import PropTypes from "prop-types";

import ConfirmDeleteDialog from "components/modals/ConfirmDeleteDialog";

const DeleteFieldModal = ({
  open,
  onOpenChange,
  label,
  modelType,
  onConfirm,
}) => (
  <ConfirmDeleteDialog
    open={open}
    onOpenChange={onOpenChange}
    title="Delete Custom Field Config?"
    description={
      <>
        Are you sure you wish to delete custom field config &quot;{label}&quot;
        and model type &quot;{modelType}&quot;?
      </>
    }
    onConfirm={onConfirm}
  />
);

DeleteFieldModal.propTypes = {
  open: PropTypes.bool,
  onOpenChange: PropTypes.func,
  label: PropTypes.string,
  modelType: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
};

export default DeleteFieldModal;
